/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { useRef } from 'react';

function usePersistFn(fn) {
  var fnRef = useRef(fn);
  fnRef.current = fn;
  var persistFn = useRef();
  if (!persistFn.current) {
    persistFn.current = function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return fnRef.current.apply(this, args);
    };
  }
  return persistFn.current;
}

export { usePersistFn };
//# sourceMappingURL=usePersistFn.js.map
